import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=cf98a978&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf98a978')) {
      api.createRecord('cf98a978', component.options)
    } else {
      api.reload('cf98a978', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=cf98a978&", function () {
      api.rerender('cf98a978', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23ho07D2vrbu6/JS/comp/openstreetmap.vue"
export default component.exports